import { Component } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { PanelIcon } from "../panel-icon.class";
import { WkIconClientCodeSpritePds3 } from "./wk-icon-client-code-sprite-pds3";

@Component({
    selector: "wk-panel-icon-client-code",
    imports: [TranslateModule, JumpstartComponentsModule, SharedModule, WkIconClientCodeSpritePds3],
    templateUrl: "./panel-icon-client-code.component.html",
    styleUrl: "./panel-icon-client-code.component.scss",
    host: { class: "wk-cm__header__icon wk-cm__header__icon-clientcode" },
})
export class PanelIconClientCodeComponent extends PanelIcon {
    protected handleOpenContact(): void {
        this.cardModalService.openContactAndSave.set(true);
    }
}
